import React, { useCallback, useEffect, useRef, useState } from 'react'
import BasicTable from '../../../../Components/CommonTable/BasicTable/BasicTable';
import CommonLayout from '../../../../Components/Common/CommonLayout';
import { columns,searchBy } from '../../../../service/RegionService';
import AddRegionModel from './AddRegionModel';
import { useFetchAll } from '../../../../custom/FetchApiHook';
import { RegionMasterApi } from '../../../../App/api/RegionMaster';

function RegionType({meta}) {
    const [search, setSearch] = useState("");
    const debounceTimeout = useRef(null);
    const { value,fetchAllData } = useFetchAll(() => RegionMasterApi.getAllRegion(pagination?pagination:{},search));
    const [selected, setSelectedData] = useState(null);
    const [deleteRegionModal, setDeleteRegionModal] = useState(false);
    const [addRegionModal, setAddRegionModal] = useState(false);
    const [regionClicked, setRegionClicked] = useState(null);
    const [pagination, setPagination] = useState({
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    });
    // console.log("region data:",value?.data?.deliveryRegions);
    
    const closeRegionModal = () => {
      setAddRegionModal(false);
      setRegionClicked(null);
    };

    useEffect(() => {
      fetchAllData()
    }, [pagination,search]);

    const filters = [];

    const handleFilter = (name, value) => {
        if (value.code === "asc" || value.code === "desc") {
          setPagination((prev) => ({
            ...prev,
            sortOrder: value.code,
          }));
        } else {
          setPagination((prev) => ({
            ...prev,
            filter: { country: value.code },
          }));
        }
    
        // console.log("e", value);
      };
    
      const handleClearFilter = () => {
        setPagination({
          page: 1,
          limit: 5,
          sortOrder: "desc",
          filter: {},
        });
      };
    
      const handleSearch = useCallback((s) => {
        setSearch(s);
      }, []);
    
      const debouncedSearch = useCallback(
        (s) => {
          if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
          }
          debounceTimeout.current = setTimeout(() => {
            handleSearch(s);
          }, 1500);
        },
        [handleSearch]
      );
      const handlePagination = (data) => {
        // console.log(data);
    
        if (data.clearPagination) {
          setPagination(data.clearPagination);
          return;
        }
        setPagination((prev) => {
          let copyfilter = { ...prev.filter };
          if (data.filter) {
            if (copyfilter[Object.keys(data.filter)[0]]) {
              copyfilter[Object.keys(data.filter)[0]] = Object.values(
                data.filter
              )[0];
            } else {
              copyfilter = { ...data?.filter, ...copyfilter };
            }
          }
          return {
            page: data.page ? data.page : prev.page,
            limit: data.limit ? data.limit : prev.limit,
            sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
            filter: copyfilter,
          };
        });
      };

      const handleRowClick = (row) => {
        // console.log("row", row);
        setRegionClicked(row);
        setAddRegionModal(true);
      };

      const onPaginatorClick = (e) => {
        if (e) {
          // console.log("Paginator Clicked", e);
          const data = {
            limit: e.rows,
            page: +e.page + 1,
          };
          handlePagination && handlePagination(data);
        }
      };
      const handleCellClicked = (row, action) => {
        // console.log("action", action);
        if (action) {
          setAddRegionModal(true);
          setRegionClicked(row);
          // console.log("row data:",row);
          
        } else {
          setRegionClicked(row);
          setDeleteRegionModal(true);
          // console.log("row data:",row);
        }
      };

    return (
        <div className="p-5">
         {/* <CommonLayout /> */}
          <BasicTable
            data={value?.data?.deliveryRegions}
            handleClearFilter={handleClearFilter}
            handleSearch={debouncedSearch}
            onPaginatorClick={onPaginatorClick}
            paginatorData={{
              filters: null,
              first: 0,
              multiSortMeta: [],
              page: value?.data?.page || 1,
              rows: value?.data?.limit || 5,
              totalPages: value?.data?.totalPages || 1,
              totalCount: value?.data?.totalCount || 1,
            }}
            selectedData={setSelectedData}
            columns={columns}
            handleFilter={handleFilter}
            handleCellClick={handleCellClicked}
            SearchBy={searchBy}
            filters={filters}
            WeekRange={false}
            button_name="Add Region"
            handleButton={() => {
              setAddRegionModal(true);
              setRegionClicked(null);
            }}
          />
          <AddRegionModel
          handleRowClick={handleRowClick}
            isOpen={addRegionModal}
            handleClose={closeRegionModal}
            data={regionClicked}
            fetchAllData={fetchAllData}
          /> 
    
          {/* <DeleteModal
            isOpen={deleteTaxModle}
            handleClose={() => setDeleteTextModal(false)}
            fetchAllData={fetchAllData}
            data={taxDataClicked}
            title="Delete Tax"
            deleteApiFunction={MasterApi.master.delteTaxMaster}
            entityName="Tax Master"
          /> */}
        </div>
      );
}

export default RegionType